// Generated by scripts/sync-version.ts. Do not edit.
export const ROXY_UI_VERSION = '0.15.0';
